import React, { useContext } from 'react';
import { getToken, signInWithGoogle } from '@app/auth/firebase';
import { useAddOrRemoveToken, useCreateUserMutation } from '@app/graphql';
import { LoginHeader, Button, Link } from '@app/components';
import {
  Container,
  Text,
  InnerContainer,
  IntroText,
  ImageContainer,
  GoogleIcon,
  MainLogo,
} from './home-components';
import { useLocation } from '@app/utils';
import { AuthContext } from '@app/providers';
import { getDefaultUrl } from '@app/routes/routes-helper';
import DefaultErroPage from '@app/components/error-pages/default-error-page';

export default function Home() {
  const { navigate } = useLocation();
  const [createUserDB] = useCreateUserMutation();
  const { userInfo } = useContext(AuthContext);
  const [addToken] = useAddOrRemoveToken();
  const [showErrorPage, SetShowErrorPage] = React.useState(false);
  React.useEffect(() => {
    if (userInfo) {
      const defaultUrl: string = getDefaultUrl(userInfo);
      navigate(defaultUrl);
    }
  }, [userInfo, navigate]);

  const setToken = async (currentUser: any, isGoogleSignIn?: boolean) => {
    const token: any = await getToken(currentUser);
    const params: any = {
      firebaseId: currentUser.uid,
      token: token.token,
      expiryDateTime: token.expiryDateTime.toString(),
      action: 'ADD',
    };
    await addToken({
      variables: params,
    })
      .then((result: any) => {})
      .catch((error: any) => {});
  };

  async function googleSignUp() {
    const currentUser = await signInWithGoogle();
    if (currentUser) {
      const {
        uid,
        displayName,
        email,
        phoneNumber: phone,
        photoURL: profilePicUrl,
      } = currentUser;
      const [firstName, lastName] = displayName
        ? displayName.split(' ')
        : ['', ''];
      createUserDB({
        variables: {
          action: 'add',
          source: 'GOOGLE',
          firebaseId: uid,
          firstName,
          lastName,
          email,
          phone: phone || '',
          profilePicUrl,
          userRoleId: '61d80b3a2224a8cd0df30225',
          userTypeId: '61d8089d2224a8cd0df30220',
        },
      })
        .then(async (res: any) => {
          await setToken(currentUser).then(() => {
            const { createUser = {} } = res.data;
            const defaultUrl: string = getDefaultUrl(createUser);
            navigate(defaultUrl);
          });
        })
        .catch((error: any) => {
          SetShowErrorPage(true);
        });
    }
  }

  return (
    <>
      {showErrorPage ? (
        <DefaultErroPage />
      ) : (
        <>
          <LoginHeader />
          <Container>
            <InnerContainer>
              <ImageContainer>
                <MainLogo />
              </ImageContainer>
              <IntroText>
                Sign in to view and complete your transactions.
              </IntroText>
              <Button
                variant="google"
                size="large"
                width="100%"
                onClick={googleSignUp}>
                <GoogleIcon>Sign Up with Google</GoogleIcon>
              </Button>
              <Button
                variant="primary"
                size="large"
                width="100%"
                onClick={() => navigate('/sign-up')}>
                Sign Up
              </Button>
              <Text>
                Do you have an account ?{' '}
                <Link href="/sign-in" variant="secondary" fontSize="14px">
                  Sign In
                </Link>
              </Text>
            </InnerContainer>
          </Container>
        </>
      )}
    </>
  );
}
